import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { 
  FaEnvelope, FaLock, FaPaperPlane, 
  FaCircleNotch, FaEye, FaEyeSlash 
} from 'react-icons/fa';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [status, setStatus] = useState({ message: '', type: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "user_email_field") {
      setFormData(prev => ({ ...prev, email: value }));
    } 
    else if (name === "user_password_field") {
      setFormData(prev => ({ ...prev, password: value }));
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus({ message: '', type: '' });

    try {
      const loginRes = await fetch(
        'https://ikaze-thouse-backend.vercel.app/api/v1/login/login',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        }
      );

      const loginData = await loginRes.json();

      if (loginData.success) {
        const userDetailsRes = await fetch(
          `https://ikaze-thouse-backend.vercel.app/api/v1/auth/email/${formData.email}`
        );

        const userDetailsJson = await userDetailsRes.json();

        const userRole =
          userDetailsJson.user?.role?.toLowerCase() || 'guest';

        localStorage.setItem(
          'user',
          JSON.stringify({
            ...loginData.user,
            role: userRole
          })
        );

        setStatus({
          message: 'Welcome back! Authentication successful.',
          type: 'success'
        });

        setTimeout(() => {
          const routes = {
            manager: '/manager',
            tenant: '/tenant',
            booking: '/tenant/BookingDash',
            owner: '/owner'
          };

          navigate(routes[userRole] || '/');
        }, 1200);
      } 
      else {
        setStatus({
          message: loginData.message || 'Invalid email or password.',
          type: 'error'
        });
      }
    } 
    catch (err) {
      console.error("Login Error:", err);
      setStatus({
        message: 'Unable to connect to server. Check your internet.',
        type: 'error'
      });
    } 
    finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      
      {/* Visual Side */}
      <div className="login-visual">
        <div className="visual-overlay">
          <div className="visual-content">
            <span className="badge-premium">GKM Invest Premium</span>
            <h2>Experience Luxury <br/> Living Redefined.</h2>
            <p>Managing high-end assets with transparency and integrity.</p>
          </div>
        </div>
      </div>

      {/* Form Side */}
      <div className="login-form-side">
        <div className="form-wrapper">
          <div className="brand-logo">GKM INVEST</div>

          <div className="form-header">
            <h1>Login</h1>
            <p>Enter your credentials to manage your properties.</p>
          </div>

          <form onSubmit={handleLogin} autoComplete="off">

            {/* Fake autofill blockers */}
            <input type="text" name="fakeuser" style={{ display: "none" }} />
            <input type="password" name="fakepass" style={{ display: "none" }} />

            {/* EMAIL */}
            <div className="input-field">
              <label>Email Address</label>
              <div className="input-wrapper">
                <FaEnvelope className="field-icon" />
                <input 
                  type="email" 
                  name="user_email_field"
                  value={formData.email}
                  autoComplete="off"
                  placeholder="name@example.com"
                  required 
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* PASSWORD */}
            <div className="input-field">
              <label>Password</label>
              <div className="input-wrapper">
                <FaLock className="field-icon" />
                <input 
                  type={showPassword ? "text" : "password"} 
                  name="user_password_field"
                  value={formData.password}
                  autoComplete="new-password"
                  placeholder="Enter your password"
                  required 
                  onChange={handleChange}
                />
                <button 
                  type="button" 
                  className="toggle-pass" 
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            {/* FORGOT PASSWORD */}
            <div className="form-help">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>

            {/* SUBMIT */}
            <button className="submit-btn" type="submit" disabled={isLoading}>
              {isLoading ? (
                <FaCircleNotch className="spin" />
              ) : (
                <>Sign In <FaPaperPlane style={{ marginLeft: '8px' }} /></>
              )}
            </button>
          </form>

          {/* SIGNUP */}
          <p className="signup-prompt">
            New to GKM Invest? <Link to="/SignUp">Join the community</Link>
          </p>

          {/* STATUS MESSAGE */}
          {status.message && (
            <div className={`notification-toast ${status.type} animate-slide-up`}>
              {status.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;